<template>
<div class="text-question">
  <div>
    <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
    <p v-if="node.prompt !== null">{{node.prompt}}</p>
    <div v-html="node.question.instructions"></div>
    <v-text-field
      id="text-input"
      v-model="content"
      outlined
      :type="node.question.input_type"
      :hint="node.question.help_text"
      persistent-hint
    ></v-text-field>
  </div>
  <div class="buttons">
    <v-btn
      class="submit-button"
      :disabled="!isValidSelection()"
      color="primary"
      @click="onAnswerQuestion">
      {{ submitButton }}
    </v-btn>
    <v-btn
      v-if="node.skippable"
      class="submit-button"
      color="secondary"
      @click="onSkipQuestion">
      {{ skipButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
export default {
  name: 'TextQuestion',
  data() {
    return {
      content: null,
    };
  },
  methods: {
    isValidSelection() {
      return this.content !== null && this.content.length > 0;
    },
    onAnswerQuestion() {
      this.$emit('answer', { node: this.node, text: this.content });
      this.content = null;
    },
    onSkipQuestion() {
      this.$emit('skip');
      this.content = null;
    },
  },
  props: {
    node: Object,
    submitButton: String,
    skipButton: String,
  },
  mounted() {
    document.getElementById('text-input').focus();
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.text-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .question-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .text-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
